// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2EW2_","checkboxCol":"Table_checkboxCol__3c5zU","emailCol":"Table_emailCol__Or5vY","actionCol":"Table_actionCol__2j9Ei"};